(function(){
  "use strict";
  var scope = document.getElementById('ns-lookbook-a');
  if(!scope) return;
  var root = scope;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.dataLayer = window.dataLayer || [];
  function store(k,v){try{localStorage.setItem(k,v);}catch(e){}}
  function read(k){try{return localStorage.getItem(k);}catch(e){return null;}}
  scope.classList.add('js');

  /* keep the lookbook clear of the theme's fixed site nav (measured, responsive) */
  function siteNavH(){ var n=document.querySelector('.nav'); return n ? Math.round(n.getBoundingClientRect().height) : 69; }
  function setNavOffset(){ var h=siteNavH(); if(h>0){ scope.style.setProperty('--site-nav-h', h+'px'); } }
  setNavOffset();
  window.addEventListener('resize', setNavOffset);

  /* Theme: Auto / Light / Dark (local to the lookbook) */
  var thBtns = Array.prototype.slice.call(scope.querySelectorAll('.th-btn'));
  function currentTheme(){ var m = read('ns-lookbook-theme'); return (m==='light'||m==='dark') ? m : 'auto'; }
  function applyTheme(mode){
    if(mode==='light'||mode==='dark'){ root.setAttribute('data-theme',mode); store('ns-lookbook-theme',mode); }
    else { root.removeAttribute('data-theme'); try{localStorage.removeItem('ns-lookbook-theme');}catch(e){} }
    thBtns.forEach(function(b){ b.setAttribute('aria-pressed', String(b.getAttribute('data-theme')===mode)); });
  }
  thBtns.forEach(function(b){ b.addEventListener('click', function(){ applyTheme(b.getAttribute('data-theme')); }); });
  applyTheme(currentTheme());

  /* District switch */
  var tabs = Array.prototype.slice.call(scope.querySelectorAll('.sw-btn'));
  var sections = {};
  scope.querySelectorAll('.district').forEach(function(s){ sections[s.getAttribute('data-district')] = s; });
  function showDistrict(name, scroll){
    Object.keys(sections).forEach(function(k){ sections[k].hidden = (k!==name); });
    tabs.forEach(function(t){ t.setAttribute('aria-selected', String(t.getAttribute('data-go')===name)); });
    store('ns-lookbook-district', name);
    if(scroll){ var barEl=scope.querySelector('.bar'); var off=siteNavH()+(barEl?barEl.offsetHeight:66)+10; var top = sections[name].getBoundingClientRect().top + window.pageYOffset - off; window.scrollTo({top: top<0?0:top, behavior: reduce?'auto':'smooth'}); }
    pushList(name);
  }
  tabs.forEach(function(t){ t.addEventListener('click', function(){ showDistrict(t.getAttribute('data-go'), true); }); });
  var savedD = read('ns-lookbook-district');
  if(savedD==='Tittallon'){ showDistrict('Tittallon', false); }

  /* Reveal (compositor-only), reduced-motion safe */
  var reveals = Array.prototype.slice.call(scope.querySelectorAll('.reveal'));
  if(reduce || !('IntersectionObserver' in window)){ reveals.forEach(function(el){ el.classList.add('in'); }); }
  else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    }, {rootMargin:'0px 0px -8% 0px', threshold:0.08});
    reveals.forEach(function(el){ io.observe(el); });
  }

  /* Heroes stay still: no hover scale or shift, so every photograph shows its whole frame. */

  /* GA4 dataLayer stubs */
  function pushList(district){
    if(!sections[district]) return; var items = [];
    scope.querySelectorAll('.district[data-district="'+district+'"] .pc-link').forEach(function(a,i){
      items.push({ item_id:((a.href.split('/products/')[1]||'').split('?')[0]), item_name:a.getAttribute('data-name'),
        item_brand:district, price:(a.getAttribute('data-price')||'').replace(/[^0-9.]/g,''), index:i }); });
    window.dataLayer.push({ event:'view_item_list', item_list_id:'ns_lookbook', item_list_name:'NS Lookbook - '+district, items:items });
  }
  scope.querySelectorAll('.pc-link, .ix-name a').forEach(function(a){
    a.addEventListener('click', function(){
      window.dataLayer.push({ event:'select_item', item_list_id:'ns_lookbook',
        items:[{ item_id:((a.href.split('/products/')[1]||'').split('?')[0]), item_name:a.getAttribute('data-name'),
          price:(a.getAttribute('data-price')||'').replace(/[^0-9.]/g,'') }] }); });
  });
  pushList(read('ns-lookbook-district')==='Tittallon'?'Tittallon':'Fenggy');
})();